import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Button, DialogActions, DialogContent, Dialog, DialogTitle, TextField, Typography } from "@mui/material";

export default function AmbassadorDealOptoutDialog(props) {
	const check_phrase = "ne plus être ambassadeur";
	const [form, setForm] = useState({ confirm: "" });
	const [disabled, setDisabled] = useState(true);
	const handleClose = () => {
		props.onClose();
	};
	const handleChange = (event) => {
		setForm({ ...form, [event.target.name]: event.target.value });
	};

	useEffect(() => {
		console.log(form.confirm, form.confirm === "supprimer " + props.state.params.name);
		setDisabled(!(form.confirm === check_phrase));
	}, [form]);
	const handleSubmitDeleteDealUser = () => {
		console.log("handleSubmitNewDeal");
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/af0127286edd46eaa924da42179a69c2/" + props.state.params.uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.href = "/dashboarda";
						//window.location.replace("/newdealv/" + res.id+"/0");
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};
	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">Quitter le dossier dont vous êtes ambassadeur</DialogTitle>
			<DialogContent dividers>
				<Typography variant="h5" gutterBottom>
					Vous souhaitez ne plus gérer ce dossier ?
				</Typography>
				<Typography variant="body1" gutterBottom>
					Le vendeur principal sera informé de votre choix et pourra demander à une autre personne de gérer le dossier ou bien l'administrer
					lui-même.
				</Typography>
				<Typography variant="body1" gutterBottom>
					Pour confirmer votre choix, merci d'écrire la phrase exactement la phrase suivante <Typography variant="h5" style={{textAlign: "center", padding: "10px"}}>{check_phrase}</Typography> en toutes lettres dans le champ ci-dessous
				</Typography>
				<div>
					<TextField
						id="confirm"
						name="confirm"
						variant="outlined"
						style={{
							marginLeft: 0,
							marginRight: 10,
						}}
						placeholder={check_phrase}
						fullWidth
						margin="dense"
						size="small"
						value={form.confirm}
						onChange={handleChange}
					/>
				</div>
			</DialogContent>

			<DialogActions>
				<Button variant="outlined" onClick={handleClose}>
					Annuler
				</Button>
				<Button
					variant="contained"
					onClick={handleSubmitDeleteDealUser}
					//style="margin: 10px;"
					disabled={disabled}
				>
					Supprimer
				</Button>
			</DialogActions>
		</Dialog>
	);
}
